import { IAppState } from '../../redux';

export function selectIsPublishToHiddenBase(state: IAppState): boolean {
  return state.publishAvailable.isPublishToHiddenBase;
}
